exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SimilarListings-paddingmobile-2LJhj {\r\n    padding: 5px 0px !important;\r\n}", ""]);

// exports
exports.locals = {
	"paddingmobile": "SimilarListings-paddingmobile-2LJhj"
};